enum CommunityTemplateTopicsGroupBindingMode {
    firstTopic = 0,
    firstUnansweredTopicOrFirst = 1,
    firstUnansweredTopicOrLast = 2,
    lastTopic = 3
}

export default CommunityTemplateTopicsGroupBindingMode